import {
	DELIVERY_TYPE_COURIER_MSK, DELIVERY_TYPE_COURIER_SPB, DELIVERY_TYPE_SELF, DELIVERY_TYPE_EXPRESS, DESTINATION_MSK,
	DESTINATION_SPB, DESTINATION_RUSSIA
} from "@/store/delivery";

export const PAYMENT_SYSTEM_ID_CARD = 2;
export const PAYMENT_SYSTEM_ID_CASH = 3;
export const PAYMENT_SYSTEM_ID_SELF = 4;	// оплата на кассе при самовывозе
export const PAYMENT_SYSTEM_ID_DEFERRED = 5;	// оплата после созвона с менеджером
export const PAYMENT_SYSTEM_ID_LINK = 6;	// оплата по ссылке
export const PAYMENT_SYSTEM_ID_LEGAL_ENTITY = 7;	// оплата для юридических лиц

// todo забирать все из бэка

export const paymentSystems = [
	{
		id: PAYMENT_SYSTEM_ID_CASH,
		label: "Наличными курьеру",
		destinationIds: [DESTINATION_MSK, DESTINATION_SPB],
		deliveryTypeIds: [DELIVERY_TYPE_COURIER_MSK, DELIVERY_TYPE_COURIER_SPB, DELIVERY_TYPE_EXPRESS],
	},
	{
		id: PAYMENT_SYSTEM_ID_SELF,
		label: "Наличными при самовывозе",
		destinationIds: [DESTINATION_MSK, DESTINATION_SPB],
		deliveryTypeIds: [DELIVERY_TYPE_SELF],
	},
	{
		id: PAYMENT_SYSTEM_ID_CARD,
		label: "Картой на сайте",
		destinationIds: [DESTINATION_MSK, DESTINATION_SPB],
		deliveryTypeIds: [DELIVERY_TYPE_COURIER_MSK, DELIVERY_TYPE_COURIER_SPB, DELIVERY_TYPE_EXPRESS, DELIVERY_TYPE_SELF],
	},
	{
		id: PAYMENT_SYSTEM_ID_LINK,
		label: "Оплата по ссылке",
		hint: "После обработки заказа менеджер<br> вышлет Вам ссылку на оплату",
		destinationIds: [DESTINATION_MSK, DESTINATION_SPB, DESTINATION_RUSSIA],
		deliveryTypeIds: [DELIVERY_TYPE_COURIER_MSK, DELIVERY_TYPE_COURIER_SPB, DELIVERY_TYPE_SELF],
		separator: true,
	},
	{
		id: PAYMENT_SYSTEM_ID_LEGAL_ENTITY,
		label: "Для юридических лиц",
		destinationIds: [DESTINATION_MSK, DESTINATION_SPB, DESTINATION_RUSSIA],
		deliveryTypeIds: [DELIVERY_TYPE_COURIER_MSK, DELIVERY_TYPE_COURIER_SPB],
	},
	{
		id: PAYMENT_SYSTEM_ID_DEFERRED,
		destinationIds: [DESTINATION_RUSSIA],
		label: "Выбор формы платежа после созвона с менеджером",
	},
];
